import { render, staticRenderFns } from "./PopUpLogin.vue?vue&type=template&id=0a83689d&scoped=true"
import script from "./PopUpLogin.vue?vue&type=script&lang=js"
export * from "./PopUpLogin.vue?vue&type=script&lang=js"
import style0 from "./PopUpLogin.vue?vue&type=style&index=0&id=0a83689d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a83689d",
  null
  
)

export default component.exports